const centerPanel = require('../../shop/views/center-panel.view.html').trim(),
    rightPanel = require('../../shop/views/right-panel.view.html').trim();

module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.catalogue', {
            url: '/catalogue',
            views: {
                'content@root': {
                    template: `${centerPanel} ${rightPanel}`,
                },
            },
            data: {
                optOutOfScrollRestore: true,
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/catalogue.js